import { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import { BasicSelectProps } from './types';

export const BasicSelect: React.FC<BasicSelectProps> = ({
  defaultValue = '',
  displayName = '',
  dataTestId,
  formControlProps = null,
  handleChange,
  helperText = '',
  id = '',
  multiple,
  options,
  required = false,
  showError = false,
  size,
  sx,
  renderValue,
}) => {
  const [selectedOption, setSelectedOption] = useState<string>(defaultValue as string);

  const onChangeHandler = (event, value) => {
    const optionValue = value.props.value || event.target.value;

    setSelectedOption(optionValue);
    handleChange(optionValue);
  };

  return (
    <FormControl size={size} {...formControlProps} sx={sx} error={showError}>
      {displayName && (
        <InputLabel disabled sx={sx}>
          {displayName}
        </InputLabel>
      )}
      <Select
        id={id}
        displayEmpty
        required={required}
        value={selectedOption}
        data-testid={dataTestId || 'basic-select'}
        label={displayName}
        sx={sx}
        size={size}
        multiple={multiple}
        onChange={(event, value) => {
          onChangeHandler(event, value);
        }}
        renderValue={renderValue}
      >
        {options.map((option) => (
          <MenuItem
            data-testid={`${dataTestId}-${option.value}-option`}
            key={option.label || option.name || option.value}
            value={option.value || option.id}
          >
            {option.label || option.name}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
